import Cookies from 'js-cookie';
import appConfig from 'appConfig';
import moduleConfig from 'moduleConfig';
import lockScreen from './lockscreen/lockscreen.vue';
import { changePass, userinfo, userInfo, login, getBoroughs } from '@/api/index';
import policyPaper from '../censusActivity/policyPaper.vue';
import LoginInfo from './loginInfo/loginInfo.vue';
import OutherPage from './outherPage/index.vue';
import axios from 'axios';
import AES from '@/utils/AES';
import applyDownHistory from './outherPage/applyDownHistory.vue';
import { signout } from '@/api/sso.js';
import { logout } from '../../api';
// import { display } from 'html2canvas/dist/types/css/property-descriptors/display';
export default {
  components: {
    policyPaper,
    lockScreen,
    LoginInfo,
    OutherPage,
    applyDownHistory,
  },
  data() {
    const valideRePassword = (rule, value, callback) => {
      if (value !== this.editPasswordForm.newPass) {
        callback(new Error('两次输入密码不一致'));
      } else {
        callback();
      }
    };
    return {
      applyDialog:false,
      NohomeBG: require('../../assets/homeImage/nohomeBG.png'),
      homeBG: require('../../assets/homeImage/headBg.png'),
      theme1: 'light',
      username: '',
      changepassModal: false,
      savePassLoading: false,
      tipStyle: 'password-tip-none',
      strength: '无',
      strengthValue: 0,
      editPasswordForm: {
        oldPass: '',
        newPass: '',
        rePass: '',
      },
      passwordValidate: {
        oldPass: [
          {
            required: true,
            message: '请输入原密码',
            trigger: 'blur',
          },
        ],
        newPass: [
          {
            required: true,
            message: '请输入新密码',
            trigger: 'blur',
          },
          {
            min: 6,
            message: '请至少输入6个字符',
            trigger: 'blur',
          },
          {
            max: 32,
            message: '最多输入32个字符',
            trigger: 'blur',
          },
        ],
        rePass: [
          {
            required: true,
            message: '请再次输入新密码',
            trigger: 'blur',
          },
          {
            validator: valideRePassword,
            trigger: 'blur',
          },
        ],
      },
      userForm: {
        id: '',
        avatar: '',
        username: '',
        sex: '',
        mobile: '',
        email: '',
        status: '',
        type: '',
        typeTxt: '',
        address: '',
        ipAddr: '',
        loginCount: '',
      },
      modaluser: false,
      layersData: [],
      ScreenType: 'unfullScreen', //非全屏状态
      Islogin: false,
      isxjActive: true,
      isgisActive: false,
      title: window.g.header.title,
      subtitle: window.g.header.subtitle,
      // logoUrl: appConfig.app.logoUrl,
      // title: '欢迎来到甘肃省旅游资源普查综合管理系统',
      // subtitle: 'Welcome to Gansu Province tourism resources census integrated management system',
      logoUrl: window.g.header.logoUrl,
      menuData: [],
      menuActive: 'censusActivity',
      menuData2: window.g.header.menuData2,
      isSelect: 'Homepage',
      rightWidth: '700px',
      rightPanel: false,
      panelTitle: '右侧面板',
      actName: '',
      showDesc: false,
      isLogin: true,
      userImg: '',
      isHomePage: false,
    };
  },
  mounted() {
    this.getUser();
    // 是否显示注销按钮
    this.showlogin();
  },
  computed: {},
  created() {
    this.init();
    this.getUser();

    let token = Cookies.get('accessToken');
    if (token) {
      this.isLogin = false;
    } else {
      localStorage.setItem('userInfo', '');
      this.isLogin = true;
    }

    // 单点登录
    // if (location.search.includes("username=")) {
    //   let usernameArr = location.search.slice(1).split("&")
    //   let username = usernameArr.filter(i => i.includes("username="))[0].split("=")[1]
    //   console.log("username", username)
    //   this.username = username
    //   login('/login', {
    //     username: username,
    //     password: 123456,
    //     saveLogin: false,
    //   }).then((res) => {
    //     if (res.success === true) {
    //       // 获取行政区划数据
    //       var param = {
    //         value: '620000',
    //       };
    //       getBoroughs(param).then((res) => {
    //         if (res.code === 200) {
    //           window.localStorage.setItem('boroughs', JSON.stringify(res.result));
    //         }
    //       });
    //       this.setStore('accessToken', res.result);
    //       Cookies.set('accessToken', res.result);
    //       // 获取用户信息
    //       userInfo().then((res) => {
    //         console.log("userInfo---", res)
    //         if (res.success === true) {
    //           this.isLogin = false
    //           var params = {
    //             id: res.result.id,
    //           };
    //           //this.getCountNumber(params) ; //add by qqjuanqq 2022-01-07 增加访问次数
    //           // 避免超过大小限制
    //           delete res.result.permissions;
    //           let roles = [];
    //           res.result.roles.forEach((e) => {
    //             roles.push(e.name);
    //           });
    //           if (
    //             roles.length > 0 &&
    //             (roles[0] == 'ROLE_ADMIN' ||
    //               roles[0] == 'ROLE_JGGLR' ||
    //               roles[0] == 'ROLE_COUNTY_CENSUES' ||
    //               roles[0] == 'ROLE_COUNTY_EXPERT' ||
    //               roles[0] == 'ROLE_CITY_EXPERTS' ||
    //               roles[0] == 'ROLE_PROVINCIAL_EXPERTS')
    //           ) {
    //             this.setStore('roles', roles);
    //             if (this.saveLogin) {
    //               // 保存7天
    //               Cookies.set('userInfo', JSON.stringify(res.result), {
    //                 expires: 7,
    //               });
    //               // 保存7天
    //               Cookies.set('username', this.form.username, {
    //                 expires: 7,
    //               });
    //               Cookies.set('autoLogin', 'true', {
    //                 expires: 7,
    //               });
    //               localStorage.setItem('userInfo', JSON.stringify(res.result));
    //             } else {
    //               Cookies.set('userInfo', JSON.stringify(res.result));
    //               Cookies.set('autoLogin', 'false', {
    //                 expires: 7,
    //               });
    //               localStorage.setItem('userInfo', JSON.stringify(res.result));
    //             }
    //             //                      this.setStore("userInfo", res.result);
    //             this.$store.commit('setAvatarPath', res.result.avatar);
    //             // 加载菜单
    //             var paramroles = '';
    //             var paramr = res.result.roles;
    //             if (null != paramr && paramr.length > 0) {
    //               paramroles = paramr[0].id;
    //             }
    //             // util.initRouter(this);
    //             this.$router.push({ name: 'Homepage' });
    //           } else {
    //             this.loading = false;
    //             this.$Message.info('该用户无权登录系统！');
    //           }
    //         } else {
    //           this.loading = false;
    //         }
    //       });
    //     } else {
    //       this.loading = false;
    //     }
    //   });
    // }
    // 获取当前的路由
    var pat = this.$route;
    if (pat.query && JSON.stringify(this.$route.query) != '{}') {
      this.actName = pat.query.ids ? pat.query.ids : 'Homepage';
    } else {
      this.actName = pat.name ? pat.name : 'Homepage';
    }
    this.isSelect = pat.name;
  },
  watch: {
    isFullScreen() {
      this.screenState();
    },
    $route: {
      handler(to, from) {
        if (to.name != 'Homepage') {
          this.isHomePage = true;
        } else {
          this.isHomePage = false;
        }
      },
      immediate: true,
    },
  },
  methods: {
    pages(src){
      this.$router.push(src)
    },
    toShowApplyHistory() {
      this.applyDialog = true;
    },
    init() {
      let v = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
      // 转换null为""
      for (let attr in v) {
        if (v[attr] === null) {
          v[attr] = '';
        }
      }
      let str = JSON.stringify(v);
      let userInfo = JSON.parse(str);
      this.userForm = userInfo;
    },
    getUser() {
      let userinfo = Cookies.get('userInfo');
      if (userinfo) {
        userinfo = JSON.parse(userinfo);
        this.username = userinfo.username ? userinfo.username : '';
        this.userImg = userinfo.avatar ? userinfo.avatar : ''; //用户头像
      }
    },
    // 前往登录页面
    toLogin() {
      // window.open(`http://192.168.1.25:9000/sso/auth?redirect=http://192.168.1.25:4523/sso/login?back=${location.origin}`, "_self");

      this.$router.push({
        path: './Login',
      });
      // const redirect = encodeURIComponent(window.location.origin);
      // window.location.href = `${window.g.baseSSo}?redirect=${redirect}?back=${redirect}`;
    },
    // 跳转到注册页面
    toRegister() {
      this.$router.push({
        path: './Register',
      });
    },
    // 点击关闭的按钮
    closeModal() {
      this.showDesc = false;
    },
    checkStrengthValue(v) {
      // 评级制判断密码强度 最高5
      let grade = 0;
      if (/\d/.test(v)) {
        grade++; //数字
      }
      if (/[a-z]/.test(v)) {
        grade++; //小写
      }
      if (/[A-Z]/.test(v)) {
        grade++; //大写
      }
      if (/\W/.test(v)) {
        grade++; //特殊字符
      }
      if (v.length >= 10) {
        grade++;
      }
      return grade;
    },
    strengthChange() {
      if (!this.editPasswordForm.newPass) {
        this.tipStyle = 'password-tip-none';
        this.strength = '无';
        this.strengthValue = 0;
        return;
      }
      let grade = this.checkStrengthValue(this.editPasswordForm.newPass);
      if (grade <= 1) {
        this.tipStyle = 'password-tip-weak';
        this.strength = '弱';
        this.strengthValue = 33;
      } else if (grade >= 2 && grade <= 4) {
        this.tipStyle = 'password-tip-middle';
        this.strength = '中';
        this.strengthValue = 66;
      } else {
        this.tipStyle = 'password-tip-strong';
        this.strength = '强';
        this.strengthValue = 100;
      }
    },
    saveEditPass() {
      this.editPasswordForm.oldPass = AES.encrypt(this.editPasswordForm.oldPass);
      this.editPasswordForm.newPass = AES.encrypt(this.editPasswordForm.newPass);
      this.editPasswordForm.rePass = AES.encrypt(this.editPasswordForm.rePass);
      let params = {
        password: this.editPasswordForm.oldPass,
        newPass: this.editPasswordForm.newPass,
        passStrength: this.strength,
      };
      this.$refs['editPasswordForm'].validate(valid => {
        if (valid) {
          this.savePassLoading = true;
          changePass(params).then(res => {
            this.savePassLoading = false;
            if (res.success === true) {
              this.$Modal.success({
                title: '修改密码成功',
                content: '修改密码成功，需重新登录',
                onOk: () => {
                  this.delCookie('accessToken');
                  this.delCookie('userInfo');
                  this.$router.push({
                    path: './Login',
                  });
                },
              });
            } else {
              this.$Message.info(res.message ? res.message : '修改失败');
            }
          });
        }
      });
    },
    cancelEditPass() {
      this.changepassModal = false;
      this.editPasswordForm = {
        oldPass: '',
        newPass: '',
        rePass: '',
      };
    },
    // 清除cook的值
    delCookie(c_name) {
      Cookies.set(c_name, '', -1);
    },
    // 用户信息详情
    usershow() {
      this.modaluser = true;
    },
    cancel() {
      this.modaluser = false;
    },
    // 退出登录请求
    Logout() {
      this.$Modal.confirm({
        title: '退出登录',
        content: '您确认要退出该系统?',
        onOk: async () => {
          // await signout();
          await  logout()
          this.delCookie('accessToken');
          this.delCookie('userInfo');
          this.delCookie('roles');
          window.localStorage.setItem('userInfo','');
          window.localStorage.setItem('roles','[]');
          this.$store.commit('setMapData', '2d');
          this.$bus.$emit('childChange', '2d');
          this.$layer.closeAll(); // 清除所有的layer弹框
          this.isLogin = true;
          // const redirect = encodeURIComponent(window.location.origin);
          // window.location.href = `${window.g.backSSo}?back=${redirect}`;

          // this.$route.name !== 'Homepage' && this.$router.push('/');
          // axios.get(`http://192.168.1.25:4523/sso/logout?userId=${userId}`).then(res => {
          //   console.log(res)
          // })
        },
      });
    },

    /**
     *
     * @param {*} name 导航菜单id，没有-id为路由，有-前面不为数字 -前为路由后为参数，-前为1 地址跳转
     *else if(name === '普查一张图'){
        this.$router.push('/geologicalData')
      }
     */
    itemSelect(name) {
      if(name === '') {
        this.$router.push('/')
      }else{
      sessionStorage.setItem('Activeheader', name);
      const routerPath = name.trim();
      if (this.$route.name == routerPath || (this.$route.name == 'Homepage' && name == '')) {
        return;
      }
      if (!routerPath.includes('-')) {

        // 没有-，id为路由
        this.$router.push({
          path: `./${routerPath}`,

        });
      } else {
        // -前面不为数字 -前为路由后为参数，-前为1 地址跳转
        let routerPathArr = routerPath.split('-');
        routerPathArr[0] == 1 && window.open(routerPathArr[1], '_blank');
        console.log(routerPathArr, 'routerPathArr')
        if (isNaN(Number(routerPathArr[0]))) {
          this.$router.push({
            path: `./${routerPathArr[0]}`,
            query: {
              value: routerPathArr[1],
            },
          });
        }
      }
    }
    },
    HandleCommand(name) {
      this.itemSelect(name)
    },
    screenState() {
      if (this.ScreenType) {
        this.ScreenType = 'fullScreen';
      } else {
        this.ScreenType = 'unfullScreen';
      }
    },
    showIcon() {
      if (this.ScreenType) {
        if (this.ScreenType === 'unfullScreen') {
          return 'ios-expand';
        } else {
          return 'ios-contract';
        }
      } else {
        return 'ios-expand';
      }
    },
    /**
     * @author zt
     * @date 2021-01-09
     * @description 修改密码
     */
    changepassOpt() {
      this.changepassModal = true;
    },
    /**
     * @author zt
     * @date 2020-06-11
     * @description 全屏
     */
    fullscreen() {
      var el = document.documentElement;
      if (this.ScreenType == 'unfullScreen') {
        this.fullScreens(el);
        //非全屏变成全屏
        this.ScreenType = 'fullScreen';
        // //这里其实就是模拟了按下键盘的F11，使浏览器全屏
        // let elem = document.getElementById('app');
        // if (elem.webkitRequestFullScreen) {
        //   elem.webkitRequestFullScreen();
        // } else {
        //   if (elem.mozRequestFullScreen) {
        //     elem.mozRequestFullScreen();
        //   } else {
        //     if (elem.msRequestFullscreen) {
        //       elem.msRequestFullscreen();
        //     } else {
        //       if (elem.requestFullScreen) {
        //         elem.requestFullscreen();
        //       } else {
        //         var wsh = new ActiveXObject('WScript.Shell');
        //         wsh.sendKeys('{F11}');
        //       }
        //     }
        //   }
        // }
      } else {
        this.exitFullScreen(el);
        //全屏变成非全屏
        this.ScreenType = 'unfullScreen';
        // if (document.exitFullscreen) {
        //   document.exitFullscreen();
        // } else if (document.mozCancelFullScreen) {
        //   document.mozCancelFullScreen();
        // } else if (document.webkitCancelFullScreen) {
        //   document.webkitCancelFullScreen();
        // } else if (document.msExitFullscreen) {
        //   document.msExitFullscreen();
        // } else {
        //   var wsh = new ActiveXObject('WScript.Shell');
        //   wsh.sendKeys('{F11}');
        // }
      }
    },

    fullScreens(el) {
      var rfs =
        el.requestFullScreen ||
        el.webkitRequestFullScreen ||
        el.mozRequestFullScreen ||
        el.msRequestFullScreen,
        wscript;

      if (typeof rfs != 'undefined' && rfs) {
        rfs.call(el);
        return;
      }

      if (typeof window.ActiveXObject != 'undefined') {
        wscript = new ActiveXObject('WScript.Shell');
        if (wscript) {
          wscript.SendKeys('{F11}');
        }
      }
    },

    exitFullScreen(el) {
      var el = document,
        cfs =
          el.cancelFullScreen ||
          el.webkitCancelFullScreen ||
          el.mozCancelFullScreen ||
          el.exitFullScreen,
        wscript;

      if (typeof cfs != 'undefined' && cfs) {
        cfs.call(el);
        return;
      }

      if (typeof window.ActiveXObject != 'undefined') {
        wscript = new ActiveXObject('WScript.Shell');
        if (wscript != null) {
          wscript.SendKeys('{F11}');
        }
      }
    },

    showlogin() {
      if (!this.username.nickname) {
        this.Islogin = false;
      } else {
        this.Islogin = true;
      }
    },

    /**
     * @author luxiaolin
     * @date 2020-01-02
     * @description 登录
     */
    loginto() {
      if (!this.username.nickname) {
        this.Islogin = true;
        this.$router.push({
          path: './Login',
        });
        return;
      } else {
        this.$router.push({
          path: '#',
        });
      }
    },
    // getUser() {
    //   let userinfo = localStorage.getItem('userInfo');
    //   if (userinfo) {
    //     userinfo = JSON.parse(userinfo);

    //     this.username = userinfo.username ? userinfo.username : '';
    //   }
    // },
  },
};



// WEBPACK FOOTER //
// ./src/view/header/Header.js